<template lang="pug">
  .shift(v-if="!shiftCanceled")

    //dropdown.menu(ref="menuButton")
      a.button.is-danger.is-outlined
        i.fa.fa-bars
      div(slot="content")
        menus
          menu-item(icon="refresh", :click="showSwitchModal") Tauschen
          menu-item(icon="times", :click="showCancelModal") Absagen

    //modal(title="Schicht absagen", :isShow="cancelModalVisible",
    //@close="cancelModalVisible=false", okText="Ja", cancelText="Nein",
    //:onOk="cancelShift")
      p Willst Du diese Schicht wirklich absagen?

    //modal(title="Schicht tauschen", :isShow="switchModalVisible",
    //@close="switchModalVisible=false", okText="Anfrage senden",
    //cancelText="Doch nicht", :onOk="switchShifts")
      p Bitte bestätige deine Tauschanfrage. Dein Bereichsleiter wird daraufhin benachrichtigt.

    .shift-name
      strong {{ shift.real_start | moment('HH:mm') }} -&nbsp;
      strong.type {{ shift.shift_type }}
    .manager(v-if="shift.shift_manager")
      strong AL: {{ shift.shift_manager }}
    .employees
      span.employee(v-for="employee in shift.employees") {{ employee }}

    .comments(v-if="shift.comments !== ''", v-html="$options.filters.linebreaks(shift.comments)")

</template>

<script>
export default {
  name: 'Shift',
  props: ['shift'],
  data () {
    return {
      cancelModalVisible: false,
      switchModalVisible: false,
      shiftCanceled: false,
      switchRequested: false
    }
  },
  methods: {
    showCancelModal: function () {
      this.cancelModalVisible = true
    },
    showSwitchModal: function () {
      if (!this.switchRequested) {
        this.switchModalVisible = true
      } else {
        this.$notify.warning({content: 'Du hast bereits eine Tauschanfrage gestellt.'})
      }
    },
    switchShifts: function () {
      let app = this
      this.$http.post('/switch-request/' + this.shift.id + '/')
        .set({Authorization: 'jwt ' + this.$root.$refs.app.loginToken})
        .then(() => {
          app.switchRequested = true
          this.$notify.danger({content: 'Tauschanfrage versendet!'})
        })
        .catch(err => {
          console.log(err.response)
          this.$notify.danger({content: err.response.body.message})
        })
    },
    cancelShift: function () {
      let app = this
      this.$http.post('/cancel-shift/' + this.shift.id + '/')
        .set({Authorization: 'jwt ' + this.$parent.loginToken})
        .then(() => {
          app.shiftCanceled = true
          this.$notify.danger({content: 'Absage versendet!'})
        })
        .catch(err => {
          console.log(err.response)
          this.$notify.danger({content: err.response.body.message})
        })
    }
  },
  created () {
  }
}
</script>


<style lang="sass" scoped>

.time, .shift-name
  font-size: 14px
span.when
  font-size: 14px

.shift-name strong
  color: cornflowerblue

.shift
  position: relative
  margin-top: 1em
  &:nth-of-type(0)
    margin-top: 0

.menu
  position: absolute
  top: 0
  right: 0

.employee
  font-weight: normal

.employee + .employee:before
  content: ', '

.comments
  padding: 15px
  background: #f4f4f4
  border: 1px solid #ce0400

</style>



// WEBPACK FOOTER //
// Shift.vue?ef4297d6